<template>
  <v-container style="max-width: 1800px">
    <v-card class="ma-4">
      <!-- <v-btn class="primary" @click="updateChartCollection">Update</v-btn> -->

      <v-toolbar color="primary" dark class="">
        <span>
          Gerador solar:
          <span v-decimal-format-3="solarPlant.dcPower"> </span> kWp
        </span>
        <v-spacer></v-spacer>
      </v-toolbar>

      <!-- <md-card-content v-if="solarPlant.production"> -->
      <v-container v-if="solarPlant.production">
        <v-row class="margin:10px">
          <v-col style="min-width:150px">
            <v-card >
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline mb-4">Potência</div>
                  <v-list-item-title class="headline mb-1">
                    <div :class="`teal--text text--darken-2`" color="">
                      <span v-decimal-format-3="solarPlant.dcPower"></span>
                      kWp
                    </div>
                  </v-list-item-title>

                  <v-list-item-subtitle> </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>

                     <v-card v-if ="!site.solarRequest.customKit && site.solarRequest.estimated">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline mb-4">Módulos</div>
                  <v-list-item-title class="headline mb-1 ">
                    <!-- <div :class="`teal--text text--darken-2`" color="">
                    {{solarPlant.nModules}}
                    
                    </div> -->
    
    <v-text-field
              
              center
              style="text-align: center;font-size:30px "
              class="center teal--text text--darken-2 "
              prepend-icon="mdi-minus"
              append-outer-icon="mdi-plus"

                  @click:append-outer = "updateGeneratorNModules(solarPlant.nModules+1)"
              @click:prepend = " updateGeneratorNModules(solarPlant.nModules-1)"
              v-model.number="solarPlant.nModules"
              @blur="updateGeneratorNModules(solarPlant.nModules)"
            ></v-text-field>


                    
                  </v-list-item-title>

                  <v-list-item-subtitle> </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col >
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline mb-4">Eficiência</div>
                  <v-list-item-title class="headline mb-1">
                    <!-- <span v-decimal-format="solarPlant.efficiency"></span> % -->
                        <v-text-field
                        :disabled= "(disabled || !accessEfficiency)"
                          v-model.number="solarPlant.efficiency"
                          suffix="%"
                          v-bind:options="$globalFunctions.optionsPercent"
                             @change="updateEfficiency"
                          style="font-size:30px!important;font-weight: lighter!important;"
                        />
                  </v-list-item-title>
                  <v-list-item-subtitle> </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-card-actions>
                <v-slider
                 :disabled= "(disabled || !accessEfficiency)"
                  v-model="solarPlant.efficiency"
                  label=""
                  @change="updateEfficiency"
                  track-color="green"
                  step="0.01"
                ></v-slider>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col>
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline mb-4">Geração anual</div>
                  <v-list-item-title class="headline mb-1">
                    <span
                      v-decimal-format="
                        (solarPlant.production.average * 12) / 1000
                      "
                    ></span>
                    MWh
                  </v-list-item-title>
                  <v-list-item-subtitle> </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>

            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline mb-4">Geração mensal</div>
                  <v-list-item-title class="headline mb-1">
                    <span
                      v-decimal-format="solarPlant.production.average"
                    ></span>
                    kWh
                  </v-list-item-title>
                  <v-list-item-subtitle> </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>

          <v-card class="ma-4" style="max-width: 90%">
            <!-- <p>Chart</p> -->
            <line-chart
              class="linechart"
              style="position: relative"
              :chart-data="dataCollection"
              :options="options"
            ></line-chart>
          </v-card>
        </v-row>
      </v-container>
      <v-card class="ma-4">
        <v-toolbar class="secondary" color="gray" dark > 
          Dados da nova conta
        </v-toolbar>
        <v-card-text>
            <v-row class="margin:10px">
              <v-col>
                        <v-card>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <div class="overline mb-4">Conta atual</div>
                              <v-list-item-title class="headline mb-1">
                                <div :class="`gray--text text--darken-2`" color="">
                                  <span v-money-format="site.electricalProps.averageBilling.total"></span>
                                </div>
                              </v-list-item-title>

                              <v-list-item-subtitle> </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>
                      <v-col>
                        <v-card>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <div class="overline mb-4">Nova conta</div>
                              <v-list-item-title class="headline mb-1">
                                <div :class="`teal--text text--darken-2`" color="">
                                  <span v-money-format="newAverageBilling.total"></span>
                                </div>
                              </v-list-item-title>

                              <v-list-item-subtitle> </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>
                      <v-col>
                        <v-card>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <div class="overline mb-4">Economia</div>
                              <v-list-item-title class="headline mb-1">
                                <div :class="`teal--text text--darken-2`" color="">
                                  <span v-money-format="newAverageBilling.savings"></span>
                                </div>
                              </v-list-item-title>

                              <v-list-item-subtitle> </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>
                      <v-col>
                        <v-card>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <div class="overline mb-4">Economia</div>
                              <v-list-item-title class="headline mb-1">
                                <div :class="`teal--text text--darken-2`" color="">
                                  <span v-decimal-format="newAverageBilling.savingsPercentage"></span>
                                  %
                                </div>
                              </v-list-item-title>

                              <v-list-item-subtitle> </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>

                      <v-col>
                        <v-card>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <div class="overline mb-4">Créditos</div>
                              <v-list-item-title class="headline mb-1">
                                <div :class="`gray--text text--darken-2`" color="">
                                  <span v-decimal-format="newAverageBilling.credits"></span>
                                  kWh
                                </div>
                              </v-list-item-title>

                              <v-list-item-subtitle> </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>

                       <v-col>
                        <v-card>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <div class="overline mb-4">Créditos (R$)</div>
                              <v-list-item-title class="headline mb-1">
                                <div :class="`gray--text text--darken-2`" color="">
                                  <span v-money-format="newAverageBilling.credits * newAverageBilling.price"></span>
                                  
                                </div>
                              </v-list-item-title>

                              <v-list-item-subtitle> </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>
            </v-row>
        </v-card-text>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import LineChart from "@/libraries/objects/LineChart.js";
export default {
  components: {
    LineChart,
  },
    name: "solar-plant-card",
  props: ["solarPlant", "dcPower","site","disabled","quote","accessEfficiency"],
computed: {
      newAverageBilling:function () {
        var billing ={
          description:"Energia ativa",
          factor:1,
          minAmount:100,
          price:0,
          quantity:0,
          total:0,
          type:"B2",
          unit:"kWh"
        };

        if(!this.solarPlant.production){
          return billing
        }
        billing = Object.assign({},this.site.electricalProps.averageBilling);
        var consumption = this.site.electricalProps.averageBilling.quantity;
        var minAmount = this.site.electricalProps.averageBilling.minAmount;
        var production = this.solarPlant.production.average ;
        var newConsumption = 0;
        var credits = 0;

        if(consumption - production < minAmount){
          newConsumption = minAmount;
          credits = production - (consumption - minAmount);
        }
          
        if(consumption - production > minAmount){
          newConsumption = consumption - production;
          credits = 0;
        }

        billing.quantity = newConsumption; 
        billing.total = billing.quantity * billing.price;
        billing.credits = credits;
        billing.savings =  this.site.electricalProps.averageBilling.total -   billing.total ;
        billing.savingsPercentage = 100* billing.savings / this.site.electricalProps.averageBilling.total ;

        return billing
      }
  

    },

  mounted() {},
  methods: {
    updateGeneratorNModules(nModules){
      //alert("updateGeneratorNModules")
        this.solarPlant.recalcGenerator(nModules);
        this.solarPlant.calcProduction();
        this.quote.loadProducts(this.solarPlant);

    },
    updateEfficiency() {
      this.solarPlant.calcProduction(this.site);
      this.updateChartCollection();
    },
    updateChartCollection() {
      if (!this.solarPlant) {
        alert("no solar plant");
        return;
      }

      console.log("updateChartCollection");
      var months = [
        "JAN",
        "FEV",
        "MAR",
        "ABR",
        "MAI",
        "JUN",
        "JUL",
        "AGO",
        "SET",
        "OUT",
        "NOV",
        "DEZ",
      ];
      var dataCollection = {
        labels: months,
        datasets: [
          {
            lineTension: 1,
            label: "kWh",
            backgroundColor: "#19b7bc",
            fill: true,
            data: [],
            // data:this.quote.hebelProps.solarPlant.monthlyProduction
          },
        ],
      };
      var options = {
        animation: {
          duration: 1000,
        },
        skipNullValues: true,
        responsive: true,
        maintainAspectRatio: false,
        bezierCurve: false,
        scales: {
          yAxes: [
            {
              //stacked: true,
              fill: true,
              gridLines: {
                display: false,
                //color: "green",
              },
              ticks: {
                //max: this.tags[this.formSearch.tagName].historyOptions.chartMax,
                min: 0,
              },
            },
          ],
        },
      };
      if (this.solarPlant.production) {
        for (var a = 0; a < this.solarPlant.production.months.length; a++) {
          dataCollection.datasets[0].data.push({
            x: months[a],
            y: this.solarPlant.production.months[a].toFixed(2),
          });
        }
        this.dataCollection = dataCollection;
        this.options = options;
      }
    },
  },

  watch: {
    dcPower: function (val) {
      this.updateChartCollection();
    },
  },
  data() {
    return {
      dataCollection: {
        datasets: [
          {
            label: "Selectionar variável",
            backgroundColor: "",
            borderColor: "white",
            fill: false,
            data: [],
          },
        ],
      },
      options: {
        animation: {
          duration: 0,
        },
        responsive: true,
        maintainAspectRatio: false,
        bezierCurve: false,
        scales: {
          yAxes: [
            {
              //stacked: true,
              fill: false,
              gridLines: {
                display: true,
                color: "gray",
              },
              ticks: {
                max: 2200,
                min: 0,
              },
            },
          ],
          xAxes: [
            {
              type: "time",
              time: {
                unit: "minute",
              },
            },
          ],
        },
      },
    };
  },
};
</script>

<style scoped>
</style>